(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steel-toes-contact"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const trigger=event.target.closest('[data-st-contact-chat]');
  if(!trigger)return;
  const widget=document.querySelector('shopify-chat');
  const activator=widget?.shadowRoot?.querySelector('button.activator');
  const fallback=trigger.closest('.st-contact__card').querySelector('[data-st-contact-fallback]');
  if(activator){fallback.hidden=true;if(activator.getAttribute('aria-expanded')!=='true')activator.click();}
  else{fallback.hidden=false;}
});

  } catch(e) { console.error(e); }
})();
})();
